export default __webpack_public_path__ + "static/media/warning--steep-descent--g6.124238e6.png";